import { ProductCategory } from 'screens/AccessExpressV3/accessExpress.types';

export interface Offer {
  id: number;
  price: string;
  bandwidth: string;
  carrier?: string;
}

export type SupportedCategories = Extract<
  ProductCategory,
  'Broadband' | 'DIA' | 'Starlink'
>;

export interface Service {
  key: ProductCategory;
  label: string;
  offers: Offer[];
}

export const SERVICES: Record<
  Extract<ProductCategory, 'Broadband' | 'DIA' | 'Starlink'>,
  Service
> = {
  Broadband: {
    key: 'Broadband',
    label: 'Broadband',
    offers: [
      {
        id: 1,
        price: '$129.00',
        bandwidth: '200/10 Mb/s',
        carrier: 'Carrier 1',
      },
      {
        id: 2,
        price: '$149.99',
        bandwidth: '300/30 Mb/s',
        carrier: 'Carrier 2',
      },
      {
        id: 3,
        price: '$213.00',
        bandwidth: '400/40 Mb/s',
        carrier: 'Carrier 3',
      },
    ],
  },
  DIA: {
    key: 'DIA',
    label: 'DIA',
    offers: [
      { id: 1, price: '$458.00', bandwidth: '500 Mb/s', carrier: 'Carrier 1' },
      { id: 2, price: '$1,025.00', bandwidth: '1 Gb/s', carrier: 'Carrier 2' },
    ],
  },
  Starlink: {
    key: 'Starlink',
    label: 'Starlink',
    offers: [
      { id: 1, price: '$264.99', bandwidth: '50 Gb/s', carrier: 'Carrier 1' },
    ],
  },
};
